import { WithStore } from 'pure-react-carousel';
import Thumbnails, { ThumbnailsProps } from './Thumbnails';

export default WithStore<ThumbnailsProps>(Thumbnails, (state) => ({
  currentSlide: state.currentSlide,
  visibleSlides: state.visibleSlides,
}));
